exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-pills{margin-bottom:25px}article img{width:100%}article h1.divide{margin-top:150px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/main/apiTest/pages/styles.less
 ** module id = 604
 ** module chunks = 0
 **/